export default function isSafariIOS() {
  if(typeof navigator === 'undefined') {
    return false
  }
  const ua = navigator.userAgent
  return /iP(hone|ad|od)/.test(ua) && /WebKit/.test(ua) && !/CriOS|FxiOS|OPiOS/.test(ua)
}
